import React, { useState } from 'react';
import { StyleSheet } from 'react-native';
import { RadioButton } from 'react-native-paper';
import i18n from 'i18n-js';

import Language from '../constants/localization';
import { Text, View } from '../components/themed-view';

// import { sequences, label, setting as sequence } from '../constants/sequence';
import { Settings } from '../models/settings';
import { useSettings } from '../constants/settings';
import { Locale, setting as translation } from '../constants/translation';
import { list } from '../translation/book';

export default function SettingsScreen() {
  const [settings, setSettings] = useState<Settings>({});
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { updateSetting } = useSettings(settings, setSettings);

  const BookTranslation = () => {
    const locale = Language.locale() as Locale;

    const update = (value: string) => updateSetting(translation, value);
    const translations = list(locale);

    return translations.length > 1 ? (
      <RadioButton.Group
        onValueChange={(newValue) => update(newValue)}
        value={settings[translation]}
      >
        {translations.map((t) => (
          <View key={t}>
            <RadioButton.Item
              label={i18n.t(['translations', t, 'authors'])}
              value={t}
            />
          </View>
        ))}
      </RadioButton.Group>
    ) : (
      <Text>
        {i18n.t('OnlyAvailableTranslation', {
          translation: i18n.t(['translations', translations[0], 'authors'])
        })}
      </Text>
    );
  };

  return (
    <View style={styles.container}>
      <View style={styles.setting}>
        <BookTranslation />
        <Text>Detected locale is {Language.locale()}</Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 2,
    alignItems: 'center',
    justifyContent: 'center'
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold'
  },
  separator: {
    marginVertical: 30,
    height: 1,
    width: '80%'
  },
  setting: {},
  settingName: {},
  picker: {}
});
